import React from "react";
import "./ListContainer.css";
import { Button } from "semantic-ui-react";
import { useMetaData } from "../../Context/MetaDataContext";
import { isMobile } from "react-device-detect";
import FearAndGreed from "../FearAndGreed/FearAndGreed";
import MostViews from "../Posts/MostViews";
import RecentPosts from "../Posts/RecentPosts";
const ListContainer = () => {
  const { handleLanguageChange } = useMetaData();
  return (
    <div className="ListContainer">
      <div style={{ alignSelf: "center", marginTop: "5px" }}>
        <Button
          basic
          centered
          compact
          // color="red"
          onClick={() => handleLanguageChange("en_US")}
        >
          English
        </Button>
        <Button
          basic
          centered
          compact
          // color="yellow"
          onClick={() => handleLanguageChange("en_VN")}
        >
          Tiếng Việt
        </Button>
      </div>

      <FearAndGreed />
      {isMobile && <RecentPosts />}
      <MostViews />
    </div>
  );
};

export default ListContainer;
